import React from "react";

export default function LineTypeInfo(props) {
  return (
    <div className="flex flex-col items-center justify-center w-full">
      <h3>{props.LineType.description}</h3>
    </div>
  );
}
